import { ItemViewModel } from '@/definitions/view-models';
import { ExternalVms } from '@/api';
import { MultisidebarItem } from '@/store/multisidebar/types';

export default async function ({ model }: MultisidebarItem<ItemViewModel<ExternalVms>>) {
  return { label: model.item?.verbose_name || model.item?.name || '' };
}
